import { createSlice } from '@reduxjs/toolkit';

interface InitialState {
  clearSearch: boolean;
}

const initialState: InitialState = {
  clearSearch: false,
};

const advisorySlice = createSlice({
  name: 'advisory',
  initialState,
  reducers: {
    clearSearch: (state) => {
      state.clearSearch = true;
    },
    resetClearSearch: (state) => {
      state.clearSearch = false;
    },
  },
});

export const advisoryActions = advisorySlice.actions;

export default advisorySlice.reducer;
